/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createAction, props } from '@ngrx/store';
import { AddFamilyInformationActionsNames } from './add-family-information-action-names';
import { AddFamilyInformationReturnCodes, InputData, ServiceType } from '../../models/family-information-model';
import { IFamilyInformationItem } from '../../components/add-family-information/add-family-information-types';
import { DeviceEquipmentDetailsDataToApply, DeviceEquipmentDetailsInputData } from '../../models/device-equipment-details-return-codes';

export const GetAddFamilyInformationDialogType = createAction(
  AddFamilyInformationActionsNames.GetAddFamilyInformationDialogType(),
  props<{ data: InputData }>()
);

export const GetAddFamilyInformationDialogTypeSuccess = createAction(
  AddFamilyInformationActionsNames.GetAddFamilyInformationDialogTypeSuccess(),
  props<{ response: string }>()
);

export const SaveFamilyInformationInXml = createAction(
  AddFamilyInformationActionsNames.SaveFamilyInformationInXml(),
  props<{ item: IFamilyInformationItem }>()
);

export const SaveFamilyInformationInXmlSuccess = createAction(
  AddFamilyInformationActionsNames.SaveFamilyInformationInXmlSuccess(),
  props<{ response: string }>()
);

export const ChangeFamilyInformationDialogDimensions = createAction(
  AddFamilyInformationActionsNames.ChangeFamilyInformationDialogDimensions(),
  props<{ height: number }>()
);

export const ChangeFamilyInformationDialogDimensionsSuccess = createAction(
  AddFamilyInformationActionsNames.ChangeFamilyInformationDialogDimensionsSuccess(),
  props<{ response: string }>()
);

export const GetPdfLocationPath = createAction(
  AddFamilyInformationActionsNames.GetPdfLocationPath()
);

export const GetPdfLocationPathSuccess = createAction(
  AddFamilyInformationActionsNames.GetPdfLocationPathSuccess(),
  props<{ response: string }>()
);

export const OpenPdfFile = createAction(
  AddFamilyInformationActionsNames.OpenPdfFile(),
  props<{ filePath: string }>()
);

export const OpenPdfFileSuccess = createAction(
  AddFamilyInformationActionsNames.OpenPdfFileSuccess(),
  props<{ response: AddFamilyInformationReturnCodes }>()
);

export const SendClosePopupAction = createAction(AddFamilyInformationActionsNames.SendClosePopupAction());

export const SendClosePopupActionSuccess = createAction(
  AddFamilyInformationActionsNames.SendClosePopupActionSuccess(),
  props<{ response: string }>()
);

export const SaveServiceType = createAction(
  AddFamilyInformationActionsNames.SaveServiceType(),
  props<{ serviceTypeToSave: ServiceType }>()
);

export const SaveServiceTypeSuccess = createAction(
  AddFamilyInformationActionsNames.SaveServiceTypeSuccess(),
  props<{ response: string }>()
);

export const DeleteServiceType = createAction(
  AddFamilyInformationActionsNames.DeleteServiceType(),
  props<{ serviceTypeToDelete: ServiceType }>()
);

export const DeleteServiceTypeSuccess = createAction(
  AddFamilyInformationActionsNames.DeleteServiceTypeSuccess(),
  props<{ response: string }>()
);

export const GetUserCustomImage = createAction(
  AddFamilyInformationActionsNames.GetUserCustomImage(),
  props<{ systemName: string, name: string }>()
);

export const GetUserCustomImageSuccess = createAction(
  AddFamilyInformationActionsNames.GetUserCustomImageSuccess(),
  props<{ response: string }>()
);

export const ValidateAndGetData = createAction(
  AddFamilyInformationActionsNames.ValidateAndGetData()
);

export const ValidateAndGetDataSuccess = createAction(
  AddFamilyInformationActionsNames.ValidateAndGetDataSuccess(),
  props<{ response: DeviceEquipmentDetailsInputData }>()
);

export const ApplyDeviceEquipmentDetails = createAction(
  AddFamilyInformationActionsNames.ApplyDeviceEquipmentDetails(),
  props<{ item: DeviceEquipmentDetailsDataToApply }>()
);

export const ApplyDeviceEquipmentDetailsSuccess = createAction(
  AddFamilyInformationActionsNames.ApplyDeviceEquipmentDetailsSuccess(),
  props<{ response: string }>()
);

